const isNumber = (value: string | number): value is number => typeof value === 'number';

export const mapWidth = (value: string | number) => {
    if (isNumber(value) && value > 0 && value <= 1) {
        return `${value * 100}%`;
    }

    if (isNumber(value) && value > 1) {
        return `${value}px`;
    }

    return value;
};
